import React, { memo } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Container, Text, Box, Flex } from "@chakra-ui/react"
import { Swiper, SwiperSlide } from "swiper/react"
import SwiperCore, { Pagination } from "swiper"

import { useRecentlyViewed } from "@app/hooks/useRecentlyViewed"
import { ProductCard } from "@app/components/Product/Card/ProductCard"

import "swiper/css"

// eslint-disable-next-line react-hooks/rules-of-hooks
SwiperCore.use([Pagination])

export const RecentlyViewed: React.FC = memo(() => {
  const { product } = useStaticQuery<GatsbyTypes.RecentlyViewedQuery>(graphql`
    query RecentlyViewed {
      product: sanityTemplateProduct {
        additionalRecently
      }
    }
  `)

  const { items } = useRecentlyViewed({ limit: 10, firstImages: 10, firstVariants: 1 })

  if (items.length == 0) return null

  return (
    <Container as="section" mb={[6.25, 12.5, 25]} px={0} py={[6.5, 12.5]} position="relative">
      <Text fontSize={["2xl", "3xl"]} as="h2" lineHeight={"base"} color="grey.text" fontWeight="500" mb={[6.25, 10]} px={[6.25, 12.5]}>
        {product?.additionalRecently}
      </Text>
      <Flex
        position="relative"
        sx={{
          ".swiper": {
            width: "100%",
          },
          ".swiper-slide": {
            height: "unset !important",
          },
          ".swiper-pagination-progressbar .swiper-pagination-progressbar-fill": {
            bg: "grey.coal",
          },
          ".swiper-pagination-progressbar": {
            bg: "grey.mid",
            height: "2px !important",
            marginX: { base: "16px", sm: "56px" },
            width: { base: "calc(100% - 32px)", sm: "calc(100% - 112px)" },
          },
        }}
      >
        <Swiper
          pagination={{ el: `#related-${product?.handle}-progress`, type: "progressbar" }}
          spaceBetween={16}
          breakpoints={{
            320: { slidesPerView: 1.5, slidesOffsetBefore: 25, slidesOffsetAfter: 16 },
            768: { slidesPerView: 4.5, slidesOffsetBefore: 56, slidesOffsetAfter: 56 },
          }}
        >
          {items.map((item, index) => (
            <SwiperSlide key={item.id}>
              <ProductCard item={item} pagePosition={index + 1} collectionHandle={""} />
            </SwiperSlide>
          ))}
        </Swiper>
        <Box
          id={`related-${product?.handle}-progress`}
          pb={0}
          top="unset !important"
          bottom="-40px"
          sx={{
            ".swiper-pagination-progressbar-fill": {
              bg: "grey.coal",
            },
          }}
        />
      </Flex>
    </Container>
  )
})
